import ShippingFields, { createValidationRules as vf } from './shipping-fields'
export { PrivateAddressDisclaimer } from './PrivateAddressDisclaimer'

export const createValidationRules = vf
export default ShippingFields
